module.exports = __webpack_public_path__ + "img/construction.34337e6e.png";